import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Provider } from 'react-redux';
import { createBrowserHistory } from "history";
import { Helmet, HelmetProvider } from 'react-helmet-async';

import Home from "./pages/home";
import OriginalScore from "./pages/original-score";
import TheFilm from "./pages/the-film";

import store from './store';
const customHistory = createBrowserHistory();
const helmetContext = {};

export default function RouteApp() {
  return (
    <HelmetProvider context={helmetContext}>      
      <Provider store={store}>
        <BrowserRouter history={customHistory}>  
          <Routes >
            <Route path='/' element={<Home/>} />
            <Route path='/original-score' element={<OriginalScore/>} />
            <Route path='/the-film' element={<TheFilm/>} /> 
          </Routes>
        </BrowserRouter>                    
      </Provider>
    </HelmetProvider>   
  );
}


